// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    IconApps,
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc,
    IconRefresh,
    IconTruckDelivery,
    IconCategory,
    IconKey,
    IconFilter,
    IconTemplate,
    IconCurrency,
    IconVideo,
    IconShoppingCart,
    IconVideoPlus,
    IconBrandProducthunt,
    IconBrandPaypay,
    IconCheck
} from '@tabler/icons';

// constant
const icons = {
    IconApps,
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc,
    IconRefresh,
    IconTruckDelivery,
    IconCategory,
    IconKey,
    IconFilter,
    IconTemplate,
    IconCurrency,
    IconVideo,
    IconShoppingCart,
    IconVideoPlus,
    IconBrandProducthunt,
    IconBrandPaypay,
    IconCheck
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const application = {
    id: 'application',
    title: <FormattedMessage id="application" />,
    icon: icons.IconApps,
    type: 'group',
    children: [
        {
            id: 'users',
            title: <FormattedMessage id="users" />,
            icon: icons.IconUserCheck,
            type: 'collapse',
            children: [
                {
                    id: 'user',
                    title: <FormattedMessage id="user" />,
                    type: 'item',
                    url: '/user/list'
                },
                {
                    id: 'admin',
                    title: <FormattedMessage id="admin" />,
                    type: 'item',
                    url: '/admin/list'
                }
            ]
        },
        {
            id: 'product',
            title: <FormattedMessage id="product" />,
            type: 'item',
            icon: icons.IconBasket,
            url: '/product/list'
        },
        {
            id: 'product-photowork',
            title: <FormattedMessage id="product-photowork" />,
            type: 'item',
            icon: icons.IconShoppingCart,
            url: '/photoworklist'
        },
        {
            id: 'product-secondpass',
            title: <FormattedMessage id="product-secondpass" />,
            type: 'item',
            icon: icons.IconShoppingCart,
            url: '/secondpasslist'
        },
        {
            id: 'video-upload',
            title: <FormattedMessage id="video-upload" />,
            type: 'item',
            icon: icons.IconVideo,
            url: '/video/list'
        },
        {
            id: 'video-audit',
            title: <FormattedMessage id="video-audit" />,
            type: 'item',
            icon: icons.IconVideoPlus,
            url: '/video/audit'
        },
        {
            id: 'currency',
            title: <FormattedMessage id="currency" />,
            type: 'item',
            icon: icons.IconCurrency,
            url: '/currency/list'
        },
        {
            id: 'category',
            title: <FormattedMessage id="category" />,
            type: 'item',
            icon: icons.IconCategory,
            url: '/category/list'
        },
        {
            id: 'appupdate',
            title: <FormattedMessage id="appupdate" />,
            type: 'item',
            icon: icons.IconRefresh,
            url: '/appupdate/list'
        },
        {
            id: 'orders',
            title: <FormattedMessage id="orders" />,
            type: 'item',
            icon: icons.IconTruckDelivery,
            url: '/order/productorder/list'
        },
        {
            id: 'subscription-orders',
            title: <FormattedMessage id="subscription-orders" />,
            type: 'item',
            icon: icons.IconBrandPaypay,
            url: '/order/subscription/list'
        },
        {
            id: 'curation',
            title: <FormattedMessage id="curation" />,
            type: 'item',
            icon: icons.IconFilter,
            url: '/curation/list'
        },
        {
            id: 'inquire',
            title: <FormattedMessage id="inquire" />,
            type: 'item',
            icon: icons.IconBrandProducthunt,
            url: '/inquire/list'
        },
        {
            id: 'requestaccess',
            title: <FormattedMessage id="requestaccess" />,
            type: 'item',
            icon: icons.IconCheck,
            url: '/requestaccess/list'
        },
        {
            id: 'security-tool',
            title: <FormattedMessage id="security-tool" />,
            type: 'item',
            icon: icons.IconKey,
            url: '/security-tool/blockip/list'
        },
        {
            id: 'variation-template',
            title: <FormattedMessage id="variation-template" />,
            type: 'item',
            icon: icons.IconTemplate,
            url: '/variation-template/list'
        }
    ]
};

export default application;
